export default {
  watch: {
    'data.error'(newVal, oldVal) {
      if (newVal && !oldVal) {
        this.$emit('error');
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-element.js